import { Component, Input, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GraphqlService } from 'src/app/services/graphql.service';
import { NotificationService } from 'src/app/services/notification.service';
import { BehaviorSubject } from 'rxjs';
import { isArray } from '@apollo/client/utilities';

@Component({
  selector: 'app-my-assignment',
  templateUrl: './my-assignment.component.html',
  styleUrls: ['./my-assignment.component.scss'],
  standalone: false
})
export class MyAssignmentComponent {
  @Input() menuItem: string = '';
  @Input() statusType: any;
  @Input() status: string = '';

  title: string;
  tableColumns: any;
  pageLengths: number = 0
  pageIndexs: number = 0

  private firmsSet = new BehaviorSubject<any[]>([]);
  public firms$ = this.firmsSet.asObservable();

  constructor(
    private apollo: GraphqlService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private router: Router,

  ) { }

  ngOnInit(): void {

    const routeData = this.route.snapshot.data;
    if (routeData) {
      this.statusType = routeData['appType'];
      this.loadAssignments();
    }

    this.tableColumns = {
      sn: 'SN',
      "application.referenceNumber": 'Reference Number',
      "application.title": 'Title',
      "status": 'Assignment Status',
      createdAtFormatted: 'Assignment Date',
      action: 'Actions',
    };

  }

  async loadAssignments(pageIndex: number = 0, pageSize: number = 10): Promise<void> {
    try {
      const result: any = await this.apollo.fetchData({
        query: "",
        variables: {
          searchDataDto: {
            pageable: { pageNumber: pageIndex, pageSize: pageSize,
              sort: { orders: { direction: 'DESC', property: "id" } }
             },
            searchCombinationType: 'And',
            searchFields: [

              isArray(this.statusType) ? {
                fieldName: 'application.applicationType.registrationTypeStatus.statusType',
                fieldValues: this.statusType,
                searchType: 'In'
              }
              :
              {
                fieldName: 'application.applicationType.registrationTypeStatus.statusType',
                fieldValue: this.statusType,
                searchType: 'Equals'
              }
            ]
          }
        }
      });
      const response = result?.data?.findMyassignment || [];
      const data = result?.data?.findMyassignment?.content || [];
      this.pageLengths = response.totalElements
      this.pageIndexs = response.number
      this.firmsSet.next(data.map(x=>awfMap(x)));

    } catch (error) {
      console.error('Error loading firms', error);
      this.notificationService.errorMessage('Failed to load firms');
    }
  }

  formatDate(date: string | Date): string {
    if (!date) return '';
    const dateObj = new Date(date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  redirectToProfile(data) {

    this.router.navigate(['application-profile'], {
      relativeTo: this.route.parent,
      state: {
        applicationUuid: data?.application.uuid,
        assignmentUuid: data?.uuid,
        assignedUuid: data?.assignedToUser?.uuid,
        assigmentStatus: data.status,
      }
    });
  }

   onPageChanged(event: { pageIndex: number, pageSize: number }) {
    this.loadAssignments(event.pageIndex, event.pageSize);
  }
}

const awfMap = (data: any) => ({
  ...data,
  createdAtFormatted: new Date(data.createdAt).toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }),
});
